import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import {
    DEFAULT_SORT,
    CASHBACK_SORT,
    NOM_SORT,
    LESPLUSPOPULAIRES_SORT,
    NOUVEAUTES_SORT,
    NBCOUPON_SORT
} from '../../../../services/directory/constants';
import {
    SORT_PARTNER_ON_CASHBACK,
    SORT_PARTNER_ON_CREATION_DATE,
    SORT_PARTNER_ON_NAME,
    SORT_PARTNER_ON_ORDER,
    SORT_PARTNER_ON_NB_COUPON
} from '../../../../services/filter/constants';
import {
    sortPartnerOnName,
    sortPartnerOnOrder,
    sortPartnerOnCreationDate,
    sortPartnerOnCashback,
    sortPartnerOnNbCoupon,
    clearSort
} from '../../../../services/filter/actions';
import { PAGE_DIRECTORY } from '../../../../services/filter/constants';

const SelectTriCashback = ({ sorter, onChange }) => {
    return (
        <select id="annuaire-tri" onChange={onChange} value={sorter}>
            <option value={LESPLUSPOPULAIRES_SORT.id}>{DEFAULT_SORT.name}</option>
            <option value={CASHBACK_SORT.id}>{CASHBACK_SORT.name}</option>
            <option value={NOM_SORT.id}>{NOM_SORT.name}</option>
        </select>
    );
};

const SelectTriCodepromo = ({ sorter, onChange }) => {
    return (
        <select id="annuaire-tri-codepromo" onChange={onChange} value={sorter}>
            <option value={NBCOUPON_SORT.id}>{DEFAULT_SORT.name}</option>
            <option value={LESPLUSPOPULAIRES_SORT.id}>{LESPLUSPOPULAIRES_SORT.name}</option>
            <option value={NOUVEAUTES_SORT.id}>{NOUVEAUTES_SORT.name}</option>
        </select>
    );
};

class SortSelectComponent extends React.Component {
    onChange = e => {
        switch (Number(e.target.value)) {
            case NOM_SORT.id:
                this.props.sortPartnerOnName(PAGE_DIRECTORY);
                break;
            case LESPLUSPOPULAIRES_SORT.id:
                this.props.sortPartnerOnOrder(PAGE_DIRECTORY);
                break;
            case NOUVEAUTES_SORT.id:
                this.props.sortPartnerOnCreationDate(PAGE_DIRECTORY);
                break;
            case CASHBACK_SORT.id:
                this.props.sortPartnerOnCashback(PAGE_DIRECTORY);
                break;
            case NBCOUPON_SORT.id:
                this.props.sortPartnerOnNbCoupon(PAGE_DIRECTORY);
                break;
            case DEFAULT_SORT.id:
                this.props.sortPartnerOnOrder(PAGE_DIRECTORY);
                break;
            default:
                this.props.clearSort(PAGE_DIRECTORY);
                break;
        }
    };

    getDefaultSorter = (sorter = {}) => {
        switch (sorter.type) {
            case SORT_PARTNER_ON_CASHBACK:
                return CASHBACK_SORT.id;
            case SORT_PARTNER_ON_NAME:
                return NOM_SORT.id;
            case SORT_PARTNER_ON_ORDER:
                return LESPLUSPOPULAIRES_SORT.id;
            case SORT_PARTNER_ON_CREATION_DATE:
                return NOUVEAUTES_SORT.id;
            case SORT_PARTNER_ON_NB_COUPON:
                return NBCOUPON_SORT.id;
            default:
                return DEFAULT_SORT.id;
        }
    };

    render() {
        const { i18n, isCodePromo, sorter } = this.props;
        const defaultSorter = this.getDefaultSorter(sorter);
        const Select = isCodePromo ? SelectTriCodepromo : SelectTriCashback;

        return (
            <div id="tri-container" className="flex-container-h flex-center-alt">
                <label htmlFor="tri" className="hidden-mobonly">
                    {i18n.SORT_BY}
                </label>
                <div className="tri-select select bt-fourth">
                    <Select sorter={defaultSorter} onChange={this.onChange} />
                </div>
            </div>
        );
    }
}

SortSelectComponent.propTypes = {
    isCodePromo: PropTypes.bool.isRequired
};

const mapStateToProps = state => {
    return {
        i18n: state.i18n.page.DIRECTORY,
        sorter: (state.filters.directory || {}).sorter
    };
};

const mapDispatchToProps = {
    sortPartnerOnName,
    sortPartnerOnOrder,
    sortPartnerOnCreationDate,
    sortPartnerOnCashback,
    sortPartnerOnNbCoupon,
    clearSort
};

export default connect(mapStateToProps, mapDispatchToProps)(SortSelectComponent);



// WEBPACK FOOTER //
// ./src/components/pages/directory/filter/SortSelectComponent.js